import React from "react";
import LoginPage from "./LoginPage/LoginPage";

export default () => (
  <LoginPage/>
);
